import { SiteConfig } from "types/site";

import data from "../../../config/yec";

export default async function getSiteConfig(): Promise<SiteConfig> {
  return data;
}
